var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "detailed-table" },
    [
      _c(
        "vxe-table",
        {
          ref: "xTable",
          attrs: {
            resizable: "",
            "show-overflow": "",
            data: _vm.value,
            "edit-config": {
              trigger: "click",
              mode: "cell",
              activeMethod: _vm.activeCellMethod,
            },
          },
          on: { "radio-change": _vm.radioChangeEvent },
        },
        _vm._l(_vm.columns, function (item, k) {
          return _c(
            "vxe-table-column",
            _vm._b(
              {
                key: k,
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("div", [
                            _vm._v(_vm._s(_vm.resetText(row, item.field))),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              "vxe-table-column",
              _vm.itemRender(item),
              false
            )
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }